import React from "react";
import PresaleLive from "./PresaleLive"; // <-- your presale box component

const PresalePage = () => {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black"
    >
      {/* Desktop Background */}
      <div
        className="absolute inset-0 hidden md:block"
        style={{
          backgroundImage: "url('/1-Photoroom.png')",
          backgroundSize: "100%",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/25" />

      {/* Center Presale Box */}
      <div className="relative z-10 flex w-full items-center justify-center px-4 py-10">
        <div className="w-full max-w-[700px]">
          <PresaleLive />
        </div>
      </div>
    </section>
  );
};

export default PresalePage;